<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <!-- <button-add @click="toAddPage"></button-add> -->
        <!-- <button-delete @deleteSelection="deleteSelection" v-if="permissionCodes.indexOf('036001003') !== -1"/> -->
        <!-- <button-upload :cathUrl="uploadUrl" @getpage="getPage" :onSuccess="onUploadSuccess" value="导入" v-if="permissionCodes.indexOf('036001004') !== -1"/> -->
      <input-select selectTitle="操作类型" :selectKey="'operationType'" :selectData="operationTypeList"  @search="search"/>
      <input-select selectTitle="状态" :selectKey="'status'" :selectData="statusList"  @search="search" style="margin-left:20px"/>
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-search  placeholder="姓名/手机号码"  @search="searchKey" />
        <button-export
          :href="exportUrl"
          :beforeDownload="beforeDownload"
          style="margin: 0 0 0 8px"
          download="download.xls"
          v-if="permissionCodes.indexOf('044004001') !== -1"
          value="导出"/>
      </div>
    </div>
    <table-main :hasOperation="false" :selection="false" :tableHead="tableHead" :tableData="tableData" :operationArr="operationArr" @deleteLine="deleteLine" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @goToModifyPage="goToModifyPage"/>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/FaceRecognition";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nAlert, nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "license-logging",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "人脸应用",
          name: "monitoring-point-management"
        },
        {
          value: "授权记录"
        }
      ],
      statusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "0",
          label: "失败"
        },
        {
          key: "1",
          label: "成功"
        }
      ],
      operationTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "添加授权",
          label: "添加授权"
        },
        {
          key: "删除授权",
          label: "删除授权"
        }
      ],
      tableHead: [
        {
          prop: "personName",
          label: "姓名"
        },
        {
          prop: "phone",
          label: "手机号码"
        },
        {
          prop: "deviceName",
          label: "摄像机"
        },
        {
          prop: "picUrl",
          label: "图片",
          isPreviewPic: true
        },
        {
          prop: "operationType",
          label: "操作类型"
        },
        {
          prop: "statusText",
          label: "状态"
        },
        {
          prop: "failureReason",
          label: "失败原因"
        },
        {
          prop: "time",
          label: "下发时间"
        }
      ],
      tableData: [],
      operationArr: ["modify", "delete"],
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1,
        operationType:"",
        status:""
      },
      uploadUrl: "",
      total: 0,
      selectionArr: [],
      exportUrl: ""
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportAuthorizeRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&operationType=${this.requestData.operationType}&status=${this.requestData.status}`;
    },
    getPage() {
      this.$axios
        .post(api.getAuthorizeRecordPage, this.requestData)
        .then(res => {
          this.total = res.data.data.total;
          let list = res.data.data.list;
          list.map(v => {
            if (v.status == "0") {
              v.statusText = "成功";
            } else {
              v.statusText = "失败";
            }
          });
          this.tableData = list;
        })
        .catch(errorHandler("获取监测点列表失败"));
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteFacePointPoint, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },
    toAddPage() {
      this.$router.push({
        name: "monitoring-point-management-add"
      });
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `monitoring_point_management_modify/${code}`
      });
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    deleteSelection() {
      if (this.selectionArr.length === 0) {
        nAlert("请先选择需要删除的物资类目");
        return false;
      } else {
        this.$confirm("是否确认删除物资类目？", "提示")
          .then(() => {
            this.deleteLine(this.selectionArr);
          })
          .catch(() => {
            console.log("取消删除");
          });
      }
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    },
    search(v) {
      this.requestData.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/FaceRecognition/LicenseLogging/LicenseLogging.vue